import React from 'react';
import {withRouter} from 'react-router-dom';


import VisuelHarmonieCuisine1 from "../visuels/harmonies/cuisine/harmonie-1.jpg";
import VisuelHarmonieCuisine2 from "../visuels/harmonies/cuisine/harmonie-2.jpg";
import VisuelHarmonieCuisine3 from "../visuels/harmonies/cuisine/harmonie-3.jpg";
import VisuelHarmonieCuisine4 from "../visuels/harmonies/cuisine/harmonie-4.jpg";
import VisuelHarmonieCuisine5 from "../visuels/harmonies/cuisine/harmonie-5.jpg";
import VisuelHarmonieCuisine6 from "../visuels/harmonies/cuisine/harmonie-6.jpg";
import VisuelHarmonieCuisine7 from "../visuels/harmonies/cuisine/harmonie-7.jpg";
import VisuelHarmonieCuisine8 from "../visuels/harmonies/cuisine/harmonie-8.jpg";
import VisuelHarmonieCuisine9 from "../visuels/harmonies/cuisine/harmonie-9.jpg";
import VisuelHarmonieCuisine10 from "../visuels/harmonies/cuisine/harmonie-10.jpg";


import VisuelHarmonieSdb1 from "../visuels/harmonies/sdb/Vue-SDB_01-Rose-nenuphar.jpg";
import VisuelHarmonieSdb2 from "../visuels/harmonies/sdb/Vue-SDB_02-Rose-blush.jpg";
import VisuelHarmonieSdb3 from "../visuels/harmonies/sdb/Vue-SDB_03-Roche-Lin-2.jpg";
import VisuelHarmonieSdb4 from "../visuels/harmonies/sdb/Vue-SDB_04-Bleu-profond-2.jpg";
import VisuelHarmonieSdb5 from "../visuels/harmonies/sdb/Vue-SDB_05-Bleu-ecume-bleu-profond-2.jpg";
import VisuelHarmonieSdb6 from "../visuels/harmonies/sdb/Vue-SDB_06-Bleu-Lagon-Bleu-ecume.jpg";
import VisuelHarmonieSdb7 from "../visuels/harmonies/sdb/Vue-SDB_07-Aigue-marine-bleu-ecume-2.jpg";
import VisuelHarmonieSdb8 from "../visuels/harmonies/sdb/Vue-SDB_08-Manganese-bleu-lagon-2.jpg";
import VisuelHarmonieSdb9 from "../visuels/harmonies/sdb/Vue-SDB_09-Gris-perle-manganese.jpg";

class AffichageProduit extends React.Component {

    visuel = "";

    redirectToHome = () => {
        const {history} = this.props;
        if (history) history.push('/');
    };

    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }


    redirectToBack = () => {
        const {history} = this.props;
        if (history) history.goBack();
    };

    componentDidMount() {
    }

    render() {
        const {params} = this.props.match;
        this.produit = this.props.produit;

        return (
            <div>
                <div className="visualiseur-affichage-produit" >
                    <h2>Peinture Multi-matériaux</h2>
                    <h3>{this.produit.nom}</h3>

                    <p>Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsumLorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</p>

                    <img src={ process.env.PUBLIC_URL + "/Visualiseur/lm/produits/" + this.produit.nuance.minos_2l +".PNG" } className="visualiseur-produit-photo" />
                    <h4>Existe en rayon :</h4>
                    <ul>
                        <li>2L (soit 12m² en 2 couches): Ref LM {this.produit.nuance.lm_2l}</li>
                        <li>75 cl (soit 5m² en 2 couches): 8502020</li>
                        <li>75 ml (testeur): 8502020</li>
                    </ul>
                </div>
            </div>);
    }

}

export default withRouter(AffichageProduit);